module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMC0uMDAxaDY0MHY0ODBIMHoiLz4KICAgIDxwYXRoIGZpbGw9IiMwMDI2N2YiIGQ9Ik0wLS4wMDFoMjEzLjMzN3Y0ODBIMHoiLz4KICAgIDxwYXRoIGZpbGw9IiNmMzE4MzAiIGQ9Ik00MjYuNjYyLS4wMDFINjQwdjQ4MEg0MjYuNjYyeiIvPgogIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/wf.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/wf.svg
// module chunks = 0